import React, { useEffect, useState } from "react";
import {
  Button,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  Input,
} from "reactstrap";
import { FaFilter } from "react-icons/fa";
import { id } from "date-fns/locale";

const UniversalFilter = ({setfilters}) => {
  const [mainDropdownOpen, setMainDropdownOpen] = useState(false);
  const [filterType, setFilterType] = useState("week"); // default current week
  const [shift, setShift] = useState("");
  const [weekValue, setWeekValue] = useState(getCurrentWeek());
  const [monthValue, setMonthValue] = useState(getCurrentMonth());
  const [dateValue, setDateValue] = useState("");
  const [customStart, setCustomStart] = useState("");
  const [customEnd, setCustomEnd] = useState("");
  const [showButtons, setShowButtons] = useState(false);

  function getCurrentWeek() {
    const today = new Date();
    const onejan = new Date(today.getFullYear(), 0, 1);
    const week = Math.ceil(
      ((today - onejan) / 86400000 + onejan.getDay() + 1) / 7
    );
    return `${today.getFullYear()}-W${String(week).padStart(2, "0")}`;
  }

  function getCurrentMonth() {
    const today = new Date();
    return `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}`;
  }

  const toggleMainDropdown = () => setMainDropdownOpen(!mainDropdownOpen);

  const handleAccept = () => {
    const selected = {
      date: filterType === "date" ? dateValue : null,
      week: filterType === "week" ? weekValue : null,
      month: filterType === "month" ? monthValue : null,
      customDate:
        filterType === "custom"
          ? { startDate: customStart, endDate: customEnd }
          : null,
      shift: shift || null,
      identifier: filterType,
    };
    setfilters(selected)
    console.log("Selected Filter Object:", selected);
    // alert(JSON.stringify(selected, null, 2));
  };

  const handleReject = () => {
    setFilterType("week");
    setShift("");
    setDateValue("");
    setWeekValue(getCurrentWeek());
    setMonthValue(getCurrentMonth());
    setCustomStart("");
    setCustomEnd("");
    setShowButtons(false);
    setfilters({
        date: null,
        week: getCurrentWeek(),
        month: null,
        customDate: null,
        shift: null,
        identifier: "week",
    })
  };

  const handleFilterChange = (value) => {
    setFilterType(value);
    setShowButtons(true);
  };

  const handleShiftChange = (value) => {
    setShift(value);
    setShowButtons(true);
  };
useEffect(() => {
    setfilters({
      date: filterType === "date" ? dateValue : null,
      week: filterType === "week" ? weekValue : null,
      month: filterType === "month" ? monthValue : null,
      customDate:
        filterType === "custom"
          ? { startDate: customStart, endDate: customEnd }
          : null,
      shift: shift || null,
      identifier: filterType,
    })
}, [])

  return (
    <div style={{ position: "relative", display: "inline-block" }}>
      <Button
        color="primary"
        onClick={toggleMainDropdown}
        style={{ display: "flex", alignItems: "center", gap: "5px" }}
      >
        <FaFilter /> Filters
      </Button>

      <Dropdown
        isOpen={mainDropdownOpen}
        toggle={toggleMainDropdown}
        direction="down" 
      >
        <DropdownMenu
          style={{
            minWidth: "250px",
            padding: "15px",
            boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
            borderRadius: "10px",
            // position: "absolute",
            // left: 0, // right aligned with button
            // top: "100%", // directly below
            position: "relative", 
            transform: "translateY(5px) translateX(-157px)",  
          }}
        > 
          <div style={{ marginBottom: "10px" }}>
            <label style={{ fontWeight: "bold" }}>Select Filter:</label>
            <Input
              type="select"
              value={filterType}
              onChange={(e) => handleFilterChange(e.target.value)}
              style={{
                marginTop: "5px",
                borderRadius: "8px",
                border: "1px solid #ccc",
              }}
            >
              <option value="date">Date</option>
              <option value="week">Week</option>
              <option value="month">Month</option>
              {/* <option value="custom">Custom Date</option> */}
            </Input>

            {filterType === "date" && (
              <Input
                type="date"
                value={dateValue}
                onChange={(e) => setDateValue(e.target.value)}
                style={{
                  marginTop: "8px",
                  borderRadius: "8px",
                  border: "1px solid #ccc",
                }}
              />
            )}

            {filterType === "week" && (
              <Input
                type="week"
                value={weekValue}
                onChange={(e) => {setWeekValue(e.target.value);setShowButtons(true)}}
                style={{
                  marginTop: "8px",
                  borderRadius: "8px",
                  border: "1px solid #ccc",
                }}
              />
            )}

            {filterType === "month" && (
              <Input
                type="month"
                value={monthValue}
                onChange={(e) => setMonthValue(e.target.value)}
                style={{
                  marginTop: "8px",
                  borderRadius: "8px",
                  border: "1px solid #ccc",
                }}
              />
            )}

            {filterType === "custom" && (
              <div style={{ marginTop: "8px" }}>
                <label style={{ fontSize: "13px" }}>Start Date</label>
                <Input
                  type="date"
                  value={customStart}
                  onChange={(e) => setCustomStart(e.target.value)}
                  style={{
                    marginTop: "4px",
                    borderRadius: "8px",
                    border: "1px solid #ccc",
                  }}
                />
                <label style={{ fontSize: "13px", marginTop: "8px" }}>
                  End Date
                </label>
                <Input
                  type="date"
                  value={customEnd}
                  onChange={(e) => setCustomEnd(e.target.value)}
                  style={{
                    marginTop: "4px",
                    borderRadius: "8px",
                    border: "1px solid #ccc",
                  }}
                />
              </div>
            )}
          </div>

          {/* Shifts Dropdown */}
          <div style={{ marginBottom: "10px" }}>
            <label style={{ fontWeight: "bold" }}>Select Shift:</label>
            <Input
              type="select"
              value={shift}
              onChange={(e) => handleShiftChange(e.target.value)}
              style={{
                marginTop: "5px",
                borderRadius: "8px",
                border: "1px solid #ccc",
              }}
            >
              <option value="">-- Select Shift --</option>
              <option value="Shift A">Shift A</option>
              <option value="Shift B">Shift B</option>
              <option value="Shift C">Shift C</option>
            </Input>
          </div>

          {/* Action Buttons */}
          {showButtons && (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "15px",
              }}
            >
              <Button color="success" onClick={handleAccept}>
                Accept
              </Button>
              <Button color="danger" onClick={handleReject}>
                Reject
              </Button>
            </div>
          )}
        </DropdownMenu>
      </Dropdown>
    </div>
  );
};

export default UniversalFilter;
